"use client";

import { useRef } from "react";

import { getCurrencyFromLocale, toCanonical, type LanguageCode } from "@repo/locale";

import { useAppDispatch } from "@repo/store/hooks";
import { setCurrency, setLocale } from "@repo/store/slices";

/**
 * Seeds the Redux `locale` slice from the URL path locale (the source of truth).
 * Runs once on mount before paint effects settle so the store reflects the path
 * locale immediately; LocaleHydrator is reduced to a fallback and no-ops while a
 * valid path locale is present. Kept as a thin client component so the locale
 * layout itself stays a server component.
 */
export default function PathLocaleSync({ code }: { code: LanguageCode }) {
  const dispatch = useAppDispatch();
  const seeded = useRef(false);

  if (!seeded.current) {
    seeded.current = true;
    dispatch(setLocale(toCanonical(code)));
    dispatch(setCurrency(getCurrencyFromLocale(code)));
  }

  return null;
}
